import React, {Component} from 'react';
import {
    Button,
    FormControl,
    Icon
} from '@sketchpixy/rubix'
import {
    ADMIN_ROLE,
    APP_ADMIN_ROLE
} from '../utils'
import LoadingContainer from "../components/LoadingContainer";
import NotificationSystem from 'react-notification-system';


class UpdateUserPassword extends Component {
    constructor(props) {
        super(props)
        this.state = {
            user: props.user,
            password: "",
            respass: "",
            fetching: false,
            showPass: true,
            showRePass : true
        }
    }
    componentDidMount() {
        this._notificationSystem = this.refs.notificationSystem
    }
    componentWillUnmount() {
    
    }
    _addNotification = (message, type, title) => {
        this._notificationSystem.clearNotifications()
        this._notificationSystem.addNotification({
            message,
            title: title,
            level: type,
            position: 'br',
            autoDismiss: 5
        })
    
    }
    onChangeValue = (e, field) => {
        let {password, respass} = this.state
        if (field === "pass") {            
            password = e.target.value 
            this.setState({password})    
        } else if (field === "repass") {            
            respass = e.target.value
            this.setState({respass})
        } 
    }

    togglePass = (src) => {
        if(src === "pass") {
            this.setState({showPass: !this.state.showPass})
        } else {
            this.setState({showRePass: !this.state.showRePass})
        }
    }

    updatePassword = () => {
        let {user, password, respass} = this.state
        const {history} = this.props
        if (password && respass) {
            if (password && password.length>4 && respass && respass.length>4)
            {
                if (password === respass){
                    let body = {
                        newPassword : password,
                        password
                    }
                    this.setState({fetching: true})
                    let token = localStorage.getItem('login_token');
                    let id = localStorage.getItem('id');
                    let headers = {'Content-Type': 'application/json'};
                    headers["Authorization"] = `Bearer ${token}`
                    let url = process.env.API_URL+"/users/"+user.id+"/password"
                    if (id === user.id) {
                        url = process.env.API_URL+"/users/me/password"
                    }
                    let method = "PUT";
                    fetch(url, {method: method, body: JSON.stringify(body), headers} )
                    .then(response => response.json())
                    .then(data => {
                        this.setState({fetching: false})
                        if (data && data.message) {
                            history.push('/admin/profile');
                        } else {
                            this._addNotification(data.message, 'error', 'Error Message: ');
                        }
                    })
                    .catch(err => {
                        this.setState({fetching: false})
                        console.error(err)
                        });
                } else {
                    this._addNotification("Password is not matching with confirm password", 'error', 'Error Message: ');
                }
            }
            else {
                this._addNotification("Name should be of at least three characters", 'error', 'Error Message: ');
            }           
        } else {
            this._addNotification("Please fill field values", 'error', 'Error Message: ');
        }
    }


    render() {
        const {
            onClose
          } = this.props
        const {user, fetching} = this.state
        return (
            <div className="overlay-msg">
                {fetching && <LoadingContainer />}
                {<NotificationSystem ref='notificationSystem'/>}
                <div className="overlay-box">
                    <div className="row">                        
                        <div className="pull-right">
                        <span style={{width: '30px', height: '30px', borderRadius: '50%', background: '#fff', marginRight: 20, cursor: 'pointer'}} onClick={e => { onClose(e);}}>X</span>
                        </div>
                    </div><br />
                    <div className="row">
                            <div className='col-sm-4'>
                                <span>Password:</span>
                            </div>
                            <div className='col-sm-7'>
                                <FormControl
                                    type={this.state.showPass? "text": "password"}
                                    className="text-field-modal"
                                    value={this.state.password}
                                    autoFocus
                                    onChange={e => this.onChangeValue(e, "pass")}
                                    >
                            </FormControl>
                            </div>
                            <div style={{textAlign: 'left', paddingLeft: 0, fontSize: 18, cursor: 'pointer'}} className='col-sm-1' onClick={e=> this.togglePass('pass')}><Icon glyph={this.state.showPass? 'glyphicon glyphicon-eye-open': 'glyphicon glyphicon-eye-close'} /></div>
                    </div><br />
                    <div className="row">
                            <div className='col-sm-4'>
                                <span>Confirm Password:</span>
                            </div>
                            <div className='col-sm-7'>
                                <FormControl
                                    type={this.state.showRePass? "text": "password"}
                                    className="text-field-modal"
                                    value={this.state.respass}
                                    onChange={e => this.onChangeValue(e, "repass")}
                                    >
                            </FormControl>
                            </div>
                            <div style={{textAlign: 'left', paddingLeft: 0, fontSize: 18, cursor: 'pointer'}} className='col-sm-1' onClick={e=> this.togglePass('repass')} ><Icon glyph={this.state.showRePass? 'glyphicon glyphicon-eye-open': 'glyphicon glyphicon-eye-close'} /></div>
                    </div><br />
                    <div className="row">
                        <div className='col-sm-11 pull-right' >
                        <Button
                            type='button'
                            name={"addNew"}
                            bsStyle='primary'
                            onClick={this.updatePassword}
                            className="list-btn"
                        >Save</Button>
                        </div>
                    </div>          
                </div>
            </div>
        );
    }
}

export default UpdateUserPassword